import { type ReactNode } from "react";
import './ReportLoader.css'
interface CircularProgressProps {
    children: ReactNode;
    title: string;
}

export function ReportLoader({ children, title }: CircularProgressProps) {
    const size = 93;
    const strokeWidth = 8;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const animationDuration = 3; // Declare the animationDuration variable

    return (
        <div className={"loader-container"}>
            <div className={"loader-circleWrapper"}>
                <svg
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    className="loader-svg"
                >
                    {/* Background circle */}
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke="#EFE9FF"
                        strokeWidth={strokeWidth}
                    />
                    {/* Purple progress circle */}
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke="var(--primary)"
                        strokeWidth={strokeWidth - 1}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        style={{
                            animation: `fillPurple ${animationDuration}s linear infinite`,
                        }}
                    />
                    {/* Light progress circle (fills over purple) */}
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke="#EFE9FF"
                        strokeWidth={strokeWidth}
                        strokeDasharray={circumference}
                        style={{
                            animation: `fillLight ${animationDuration}s linear infinite`,
                        }}
                    />
                </svg>
                <div className={"loader-iconContainer"}>{children}</div>
            </div>
            <p className={"loader-title"}>{title}</p>
            <style>{`
            @keyframes fillPurple {
            0% {
                stroke-dashoffset: ${circumference};
            }
            50% {
                stroke-dashoffset: 0;
            }
            100% {
                stroke-dashoffset: 0;
            }
            }
            @keyframes fillLight {
            0% {
                stroke-dashoffset: ${circumference};
            }
            50% {
                stroke-dashoffset: ${circumference};
            }
            100% {
                stroke-dashoffset: 0;
            }
            }
        `}</style>
        </div>
    );
}
